<template lang="pug">
div
  template(v-if="!isLoggedIn")
    login
    signUp
    //- forgotPassword
  .top-wrapper
    .bbg
    .container
      .header
        .logo
          img(src='/newplayer/img/logo.png')
        .navi
          a.btn-login(href="javascript:void(0)" @click="$router.push('/login').catch(err => {})") Login
          a.btn-register(:href="openRegister" target="_blank") Register
      toptendw
      .banner-wrapper
        .banner
          .top
            img(src='/newplayer/img/banner.png')
          div Epicwin offers a fantastic opportunity with free credit RM10, 
            b NO DEPOSIT REQUIRED!
            br
            | Just sign up, and you'll receive RM10 in free credits to explore a wide range of casino games.
          a.cta(:href="openRegister" target="_blank")
            img(src='/newplayer/img/cta.png')
        .steps
          div
            img(src='/newplayer/img/1.png')
          div
            img(src='/newplayer/img/2.png')
          div
            img(src='/newplayer/img/3.png')
  .content-wrapper
    .promobox
      .promo-item
        .promo-pic
          .promo-more-info
            router-link(to="/promotions")
              i.fas.fa-info-circle
          img.w-100.img-fluid(src='/newplayer/img/promo/monthly15.jpg')
          div
            .promo-detail-wrapper
              .promo-detail-col
                .promo-info-title Deposit:
                .promo-info-amount.highlight MYR 50
              .promo-detail-col
                .promo-info-title Bonus
                .promo-info-amount MYR 15
        .promo-btn-wrap
          a.btn-submit.btn-more(href="javascript:void(0)") More Info
          a.btn-submit(href="javascript:void(0)") Claim my offer!
      .promo-item
        .promo-pic
          .promo-more-info
            router-link(to="/promotions")
              i.fas.fa-info-circle
          img.w-100.img-fluid(src='/newplayer/img/promo/comeback50.jpg')
          div
            .promo-detail-wrapper
              .promo-detail-col
                .promo-info-title Bonus:
                .promo-info-amount.highlight MYR 20 + 30
              .promo-detail-col
                .promo-info-title Accumulate Total
                .promo-info-amount MYR 500
        .promo-btn-wrap
          a.btn-submit.btn-more(href="javascript:void(0)") More Info
          a.btn-submit(href="javascript:void(0)") Claim my offer!
      .promo-item
        .promo-pic
          .promo-more-info
            router-link(to="/promotions")
              i.fas.fa-info-circle
          img.w-100.img-fluid(src='/newplayer/img/promo/casinoweekend.jpg')
          div
            .promo-detail-wrapper
              .promo-detail-col
                .promo-info-title Deposit:
                .promo-info-amount.highlight MYR 50
              .promo-detail-col
                .promo-info-title Bonus
                .promo-info-amount MYR 12.5
              .promo-detail-col
                .promo-info-title Withdrawal Requirement:
                .promo-info-amount Turnover x20
        .promo-btn-wrap
          a.btn-submit.btn-more(href="javascript:void(0)") More Info
          a.btn-submit(href="javascript:void(0)") Claim my offer!
      .promo-item
        .promo-pic
          .promo-more-info
            router-link(to="/promotions")
              i.fas.fa-info-circle
          img.w-100.img-fluid(src='/newplayer/img/promo/casino15.jpg')
          div
            .promo-detail-wrapper
              .promo-detail-col
                .promo-info-title Deposit:
                .promo-info-amount.highlight MYR 30
              .promo-detail-col
                .promo-info-title Bonus
                .promo-info-amount MYR 4.5
              .promo-detail-col
                .promo-info-title Withdrawal Requirement:
                .promo-info-amount Turnover x20
        .promo-btn-wrap
          a.btn-submit.btn-more(href="javascript:void(0)") More Info
          a.btn-submit(href="javascript:void(0)") Claim my offer!
    .container.ver-des
      .video-wrapper
        a(href="javascript:void(0)" data-bs-toggle='modal' data-bs-target='#videoModal')
          img(src='/newplayer/img/ambassador.png')
      .faq-wrapper
        h3 FAQ
        #accordion.accordion
          .accordion-item
            h2#headingOne.accordion-header
              button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseOne' aria-expanded='true' aria-controls='collapseOne')
                | What bonuses and promotions are available for new players at EpicWin?
            #collapseOne.accordion-collapse.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion')
              .accordion-body
                | As a new player at EpicWin, you can take advantage of various bonuses and promotions. Look out for welcome bonuses, which often include deposit matches and free spins. Be sure to read the terms and conditions to understand wagering requirements and eligibility.
          .accordion-item
            h2#headingTwo.accordion-header
              button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseTwo' aria-expanded='false' aria-controls='collapseTwo')
                | How do I create an account and start playing at EpicWin?
            #collapseTwo.accordion-collapse.collapse(aria-labelledby='headingTwo' data-bs-parent='#accordion')
              .accordion-body
                | To create an account, visit the EpicWin website and click on the 'Sign Up Now' button. Fill in your details, choose a secure password, and verify your email address. Once registered, you can make a deposit and start playing. Consider exploring different games to find ones you enjoy the most.
          .accordion-item
            h2#headingThree.accordion-header
              button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseThree' aria-expanded='false' aria-controls='collapseThree')
                | What payment methods are accepted for deposits and withdrawals at EpicWin?
            #collapseThree.accordion-collapse.collapse(aria-labelledby='headingThree' data-bs-parent='#accordion')
              .accordion-body
                | EpicWin offers a variety of payment methods, including credit/debit cards, e-wallets, and bank transfers. Choose a method that is convenient and secure for you. Remember to check for any fees or processing times associated with your chosen method.
          .accordion-item
            h2#headingFour.accordion-header
              button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseFour' aria-expanded='false' aria-controls='collapseFour')
                | How can I verify my account at EpicWin?
            #collapseFour.accordion-collapse.collapse(aria-labelledby='headingFour' data-bs-parent='#accordion')
              .accordion-body
                | To verify your account at EpicWin, provide your mobile phone number during registration or in your account settings. You'll receive a verification code (TAC) via SMS. Enter this TAC code on the EpicWin platform to confirm your phone number. This simple step ensures the security of your account, enabling you to access all features, including deposits, withdrawals, and promotions.
          .accordion-item
            h2#headingFive.accordion-header
              button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseFive' aria-expanded='false' aria-controls='collapseFive')
                | What games are popular among new players at EpicWin?
            #collapseFive.accordion-collapse.collapse(aria-labelledby='headingFive' data-bs-parent='#accordion')
              .accordion-body
                | New players often enjoy exploring a variety of games, including online slots, fishing games, and live dealer casino. Popular slots like Sugar Rush and table games like blackjack and roulette are great places to start. Experiment with different games to find your favorites and utilize free demos to practice.
          .accordion-item
            h2#headingSix.accordion-header
              button.accordion-button.collapsed(type='button' data-bs-toggle='collapse' data-bs-target='#collapseSix' aria-expanded='false' aria-controls='collapseSix')
                | What is so special about EpicWin in terms of new players ?
            #collapseSix.accordion-collapse.collapse(aria-labelledby='headingSix' data-bs-parent='#accordion')
              .accordion-body
                | EpicWin stands out for new players due to its user-friendly platform, generous bonuses such as Free Credit RM10, and a wide selection of games. New players can enjoy a smooth registration process and benefit from special promotions designed to enhance their gaming experience.
  #videoModal.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo
      .modal-content
        .modal-body.modal-iframe
          iframe(src='https://www.youtube.com/embed/8voPrRjuYLM?autoplay=1&amp;mute=1&amp;loop=1')


</template>
<script>
import toptendw from '@/components2/_topTenDw.vue'
import login from "@/components2/_login.vue"
import signUp from "@/components2/_signUp.vue"
import forgotPassword from "@/components2/_forgotPassword.vue"
export default{
  components:{
    toptendw,
    login,
    signUp,
    forgotPassword
  },
  data(){
    return{
      filterList : [
        "https://epic11.co/",
        "http://epic11.co/",
        "https://www.epic11.co/",
        "http://www.epic11.co/",
        "http://localhost/"
      ],
      filterList1 : [
        "https://epic11.net/",
        "http://epic11.net/",
        "https://www.epic11.net/",
        "http://www.epic11.net/",
      ],
      filterList2 : [
        "https://epic188.asia/",
        "http://epic188.asia/",
        "https://www.epic188.asia/",
        "http://www.epic188.asia/",
      ],
      feedback: {
        success: true,
        status: ""
      },
      metaData: []
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    openRegister(){
      // var filterList= [
      //   "https://epic11.co/",
      //   "http://epic11.co/",
      //   "https://www.epic11.co/",
      //   "http://www.epic11.co/",
      // ]
      // var filterList1 = [
      //   "https://epic11.net/",
      //   "http://epic11.net/",
      //   "https://www.epic11.net/",
      //   "http://www.epic11.net/",
      // ]
      // var filterList2 = [
      //   "https://epic188.asia/",
      //   "http://epic188.asia/",
      //   "https://www.epic188.asia/",
      //   "http://www.epic188.asia/",
      // ]
      var site = window.location.protocol + "//" + window.location.hostname + "/";
      if(this.filterList.includes(site)){
        if(this.$route.query.ref){
          return "https://epic11.co/register?ref=REF0000357419"
        }else{
          return "https://epic11.co/register?ref=REF0000000092"
        }
      }
      if(this.filterList1.includes(site)){
        return "https://epic11.net/register?ref=REF0000001439"
      }
      if(this.filterList2.includes(site)){
        return "https://epic188.asia/register?ref=REF0000000105"
      }
      return site
    }
  },
  mounted() {
    // Create a link element
    this.styleElement = document.createElement('link');
    this.styleElement.rel = 'stylesheet';
    this.styleElement.href = '/newplayer/css/style.css';
    this.styleElement.id = 'my-component-style';

    // Append the link element to the head
    document.head.appendChild(this.styleElement);
    this.addGa()
    // this.getSeo()
  },
  beforeDestroy() {
    // Remove the link element
    if (this.styleElement) {
      document.head.removeChild(this.styleElement);
    }
    // Remove the GA script when this component is destroyed (user navigates away)
    const gaScript = document.getElementById('ga-script');
    if (gaScript) {
      gaScript.remove();
    }

    // Optionally, clear the dataLayer if you want to reset GA data
    window.dataLayer = [];
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    addGa(){
      var site = window.location.protocol + "//" + window.location.hostname + "/";
      if(this.filterList.includes(site)){
        if (!window.dataLayer) {
          window.dataLayer = [];
        }
        function gtag() {
          window.dataLayer.push(arguments);
        }

        gtag('js', new Date());
        gtag('config', 'G-4T8GGPW5P5');
        if (!document.getElementById('gtag-script')) {
          const script = document.createElement('script');
          script.id = 'gtag-script';
          script.async = true;
          script.src = "https://www.googletagmanager.com/gtag/js?id=G-4T8GGPW5P5"; // Replace with your Google Tag ID
          document.head.appendChild(script);
        }
      }
      if(this.filterList1.includes(site)){
        if (!document.getElementById('ga-script')) {
          if (!window.dataLayer) {
            window.dataLayer = [];
          }
          function gtag() {
            window.dataLayer.push(arguments);
          }

          gtag('js', new Date());
          gtag('config', 'G-6HH3HSRXEK');
          if (!document.getElementById('gtag-script')) {
            const script = document.createElement('script');
            script.id = 'gtag-script';
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=G-6HH3HSRXEK"; // Replace with your Google Tag ID
            document.head.appendChild(script);
          }
        }
      }
      if(this.filterList2.includes(site)){
        if (!document.getElementById('ga-script')) {
          if (!window.dataLayer) {
            window.dataLayer = [];
          }
          function gtag() {
            window.dataLayer.push(arguments);
          }

          gtag('js', new Date());
          gtag('config', 'G-98GGJLRJKY');
          if (!document.getElementById('gtag-script')) {
            const script = document.createElement('script');
            script.id = 'gtag-script';
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=G-98GGJLRJKY"; // Replace with your Google Tag ID
            document.head.appendChild(script);
          }
        }
      }
    },
  }
}
</script>
<style scoped>
/* @import '~/newplayer/css/style.css'; */
/* @import url('/newplayer/css/style.css') */
</style>